/**
 * Toast POS System Name Mapping
 * Maps store shortName to the system name used in Toast POS
 */

export const toastNameMapping = {
  "Ankeny": "Ankeny, IA",
  "Baybrook": "Baybrook",
  "Bell Tower": "Bell Tower",
  "Hoover": "Birmingham (Hoover)",
  "Boca": "Boca Fashion Village",
  "Brookfield": "Brookfield",
  "Brooklyn": "Brooklyn",
  "Casa Paloma": "Casa Paloma",
  "Cinco Ranch": "Cinco Ranch",
  "CITYCENTRE": "City Centre",
  "Fort Worth": "Clearfork",
  "DATG Palm Beach": "DATG",
  "WW DC Ranch": "DC Ranch",
  "Destin": "Destin",
  "Domain": "Domain",
  "First Colony": "First Colony",
  "El Paso": "Fountains at Farrah",
  "Fritz Farm": "Fritz Farm",
  "Grapevine": "Grapevine",
  "Green Valley": "Green Valley",
  "Highland Village": "Highland Village",
  "Huntsville": "Huntsville",
  "La Cantera": "La Cantera",
  "La Palmera": "La Palmera",
  "Irving": "Las Colinas",
  "Legacy": "Legacy",
  "Meridian": "Meridian",
  "Mt. Pleasant": "Mt. Pleasant",
  "Old Town": "Old Town",
  "Palazzo": "Palazzo",
  "Park Lane": "Park Lane",
  "Park West": "Park West",
  "Prairiefire": "Prairiefire",
  "Quarry Village": "Quarry Village",
  "Realm": "Realm",
  "San Tan": "San Tan",
  "SQ": "Scottsdale Quarter",
  "South Rainbow": "South Rainbow",
  "Sparks": "Sparks",
  "Stone Oak": "Stone Oak",
  "Towncenter": "Towncenter",
  "Watters Creek": "Watter's Creek",
  "West Des Moines": "West Des Moines, IA",
  "West Village": "West Village",
  "WS West Shore": "Westshore"
};

/**
 * Get the Toast system name for a store
 * @param {string} shortName - The store's short name
 * @returns {string} The corresponding Toast system name, or the original shortName if no mapping exists
 */
export function getToastSystemName(shortName) {
  return toastNameMapping[shortName] || shortName;
}

/**
 * Check if a store has a Toast name mapping
 * @param {string} shortName - The store's short name
 * @returns {boolean} True if a mapping exists
 */
export function hasToastMapping(shortName) {
  return shortName in toastNameMapping;
}